// @ts-nocheck
import { getFormById } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import { SetFormHandlerParameter } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = SetFormHandlerParameter;

type HandlerType = Handler<Parameter>;

export const DispatchInput: HandlerType = props => {
    const formExist = getFormById(props.getState(), props.parameter.formId);

    if (!formExist) {
        props.dispatch({
            type: "Foundation/Components/Form/SetForm",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchInput];

const setForm = createHandlerChainRunner(chain, "SetForm");

export default setForm;
